var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_event",
    transform: "translate(1.000000, 0.000000)",
    fill: "#1D3648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1666667,10 L8,10 L8,14.1666667 L12.1666667,14.1666667 L12.1666667,10 L12.1666667,10 Z M11.3333333,0.833333333 L11.3333333,2.5 L4.66666667,2.5 L4.66666667,0.833333333 L3,0.833333333 L3,2.5 L2.16666667,2.5 C1.24166667,2.5 0.508333333,3.25 0.508333333,4.16666667 L0.5,15.8333333 C0.5,16.75 1.24166667,17.5 2.16666667,17.5 L13.8333333,17.5 C14.75,17.5 15.5,16.75 15.5,15.8333333 L15.5,4.16666667 C15.5,3.25 14.75,2.5 13.8333333,2.5 L13,2.5 L13,0.833333333 L11.3333333,0.833333333 L11.3333333,0.833333333 Z M13.8333333,15.8333333 L2.16666667,15.8333333 L2.16666667,6.66666667 L13.8333333,6.66666667 L13.8333333,15.8333333 L13.8333333,15.8333333 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.89ba1b750c6a6946cca107c4233b12f9.svg";
export { ForwardRef as ReactComponent };